import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-stone-50">
        <p className="text-ink-soft text-sm tracking-wider uppercase">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/dashboard/login" replace />;
  return children;
}
